import { makeStyles } from '@material-ui/styles'

const style = makeStyles((theme) => ({
  labelRoot: {
    color: theme.palette.text.primary,
  },
}))

export default style
